import { color, border } from 'styled-system';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { withProps } from 'recompose';

export const EditButtonsWrap = styled.div`
  // background: white;
  width: max-content;
  position: absolute;
  right: 0;
  top: 10px;
  // height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 1em;
  z-index: 9;
`;

const moreLinkStyles = css`
  line-height: 29px;
  font-size: 16px;
  // border-bottom: 1px solid #333;
  color: #333;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 10px 15px;
  width: 220px;
  border-radius: 10px;
  justify-content: flex-start;
  ${color};

  &:hover {
    background: #F5EEF8;
  }
  svg {
    margin-right: 5px;
  }
`;

export const MoreLink = withProps({ type: 'button ' })(styled.button`
  ${moreLinkStyles};
  ${border};
`);

export const MoreLinkAnchor = styled.a`
  ${moreLinkStyles};
  ${border};
  text-decoration: none;
`;

export const StoryMediumWrap = styled.div`
  // overflow: hidden;
  position: relative;
  min-height: ${props => (props.editing && '90px') || 'none'};
`;

export const Wrap = styled.div`

`;
